//Include Both Helper File with needed methods
// import {
//   postJwtLogin,

// } from "../../../helpers/fakebackend_helper";
import { loginSuccess, logoutUserSuccess, apiError, signUpApiError, signUpSuccess } from "./reducer";
import { deleteTenantById, getAllTenant, getTenantAppConfig, getTenantById, postCreateTenant, postLogin, postSignUp, updateTenant } from "../../../../helpers/backend_helper";
import { getDefaultTenantConfig, normalizeTenantConfig, TENANT_CONFIG_STORAGE_KEY } from "../../../../helpers/tenantConfig";

export const loginUser =
  (email: any, password: any) => async (dispatch: any) => {
    try {
      const response: any = await postLogin({ email, password });
      if (response && response.data && response.isSuccess) {
        localStorage.setItem(
          "access_token",
          JSON.stringify(response.data.token)
        );
        const userMain = JSON.stringify(response.data.user);
        localStorage.setItem("user", userMain);

        try {
          const tenantConfigResponse: any = await getTenantAppConfig();
          const tenantConfig = tenantConfigResponse?.isSuccess
            ? normalizeTenantConfig(tenantConfigResponse.data)
            : getDefaultTenantConfig();
          localStorage.setItem(TENANT_CONFIG_STORAGE_KEY, JSON.stringify(tenantConfig));
        } catch (error) {
          localStorage.setItem(
            TENANT_CONFIG_STORAGE_KEY,
            JSON.stringify(getDefaultTenantConfig())
          );
        }

        dispatch(loginSuccess(userMain));
        return { success: true, data: userMain };
      } else {
        dispatch(apiError(response));
        return { message:response.message, success: false };
      }
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, error };
    }
  };

export const createTenantBySuperAdmin =
  (payload: any) => async (dispatch: any) => {
    try {
      const response: any = await postCreateTenant(payload);
      if (response?.isSuccess) {
        return { success: true, data: response.data, message: response.message };
      }
      dispatch(apiError(response));
      return { success: false, message: response?.message || "Tenant creation failed" };
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, message: error?.message || "Tenant creation failed" };
    }
  };

export const fetchTenants =
  (page: number, count: number, keyword: string) => async (dispatch: any) => {
    try {
      const response: any = await getAllTenant(page, count, keyword);
      if (response?.isSuccess) {
        return { success: true, data: response.data, message: response.message };
      }
      dispatch(apiError(response));
      return { success: false, data: null, message: response?.message || "Failed to fetch tenants" };
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, data: null, message: error?.message || "Failed to fetch tenants" };
    }
  };

export const fetchTenantById =
  (id: string) => async (dispatch: any) => {
    try {
      const response: any = await getTenantById(id);
      if (response?.isSuccess) {
        return { success: true, data: response.data, message: response.message };
      }
      dispatch(apiError(response));
      return { success: false, data: null, message: response?.message || "Failed to fetch tenant" };
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, data: null, message: error?.message || "Failed to fetch tenant" };
    }
  };

export const editTenantBySuperAdmin =
  (payload: any) => async (dispatch: any) => {
    try {
      const response: any = await updateTenant(payload);
      if (response?.isSuccess) {
        return { success: true, data: response.data, message: response.message };
      }
      dispatch(apiError(response));
      return { success: false, message: response?.message || "Tenant update failed" };
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, message: error?.message || "Tenant update failed" };
    }
  };

export const removeTenantBySuperAdmin =
  (id: string) => async (dispatch: any) => {
    try {
      const response: any = await deleteTenantById(id);
      if (response?.isSuccess) {
        return { success: true, data: response.data, message: response.message };
      }
      dispatch(apiError(response));
      return { success: false, message: response?.message || "Tenant delete failed" };
    } catch (error: any) {
      dispatch(apiError(error));
      return { success: false, message: error?.message || "Tenant delete failed" };
    }
  };
export const signupAdmin =
  (name:string,email: any, password: any) => async (dispatch: any) => {
    try {
      const response: any = await postSignUp({ name,email, password });
      if (response && response.data && response.isSuccess) {
                dispatch(signUpSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        dispatch(signUpApiError(response));
        return { message:response.message, success: false };
      }
    } catch (error: any) {
      dispatch(signUpApiError(error));
      return { success: false, error };
    }
  };

export const logoutUser = () => async (dispatch: any) => {
  try {
    sessionStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem(TENANT_CONFIG_STORAGE_KEY);
    // let fireBaseBackend: any = getFirebaseBackend();
    dispatch(logoutUserSuccess(true));
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
